const API_DOMAIN = process.env.REACT_APP_API_URL || 'http://localhost:7070';

export default API_DOMAIN;

